<h3 mat-dialog-title class="pb-4">Cambio password</h3>
<mat-dialog-content >
   <form [formGroup]="frmGrpUser"
          class="form-container">
      <mat-form-field appearance="fill" class="w-full" autocomplete="nope">
         <mat-label>Crea una password</mat-label>
         <input matInput [type]="hidepw ? 'password' : 'text'" formControlName="password" autocomplete="nope"
                readonly onfocus="this.removeAttribute('readonly')"
                tabindex="1">
         <button mat-icon-button matSuffix tabindex="-1"
                 (click)="hidepw = !hidepw"
                 [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hidepw">
            <mat-icon>{{hidepw ? 'visibility_off' : 'visibility'}}</mat-icon>
         </button>
         <mat-error *ngIf="frmGrpUser.get('password')?.hasError('required')">
            La password è <strong>obbligatoria</strong>
         </mat-error>
         <mat-hint>La password deve contenere almeno 8 caratteri alfanumerici</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-full mt-3">
         <mat-label>Conferma la password</mat-label>
         <input matInput [type]="hidepw2 ? 'password' : 'text'"
                readonly onfocus="this.removeAttribute('readonly');"
                tabindex="2"
                formControlName="confirm_password" autocomplete="nope" >
         <button mat-icon-button matSuffix tabindex="-1"
                 (click)="hidepw2 = !hidepw2"
                 [attr.aria-label]="'Nascondi password'" [attr.aria-pressed]="hidepw2">
            <mat-icon>{{hidepw2 ? 'visibility_off' : 'visibility'}}</mat-icon>
         </button>
         <mat-error *ngIf="frmGrpUser.get('confirm_password')?.hasError('required')">
            La password è <strong>obbligatoria</strong>
         </mat-error>
         <mat-error *ngIf="frmGrpUser.hasError('not_same_pswd')">
            Le password non corrispondono
         </mat-error>
      </mat-form-field>
   </form>
</mat-dialog-content>
<mat-dialog-actions>
   <button mat-raised-button mat-dialog-close class="mr-3"
           tabindex="3">Annulla</button>
   <button mat-raised-button color="warn"
           tabindex="4"
          (click)="clickCambioPsw()">Conferma</button>
</mat-dialog-actions>
